import { style } from '@vanilla-extract/css';
import { PlumaProgressBar } from '@customerio/pluma-components/css/components';
import { themeVars } from '@customerio/pluma-components/css/theme-tokens';

export const popoverContent = style(
  {
    width: '460px',
    maxWidth: '90vw',
    padding: themeVars.space['200'],
  },
  'addon-popover-content',
);

const box = style(
  {
    border: `${themeVars.border['width-0125']} solid ${themeVars.color['scope-neutral-subtle-border']}`,
    borderRadius: themeVars.radius['8'],
    padding: `${themeVars.space['100']} ${themeVars.space['150']}`,
  },
  'addon-popover-box',
);

export const offerBox = style([box], 'addon-popover-offer-box');

export const includedBox = style(
  [
    box,
    {
      borderColor: themeVars.color['scope-accent-subtle-border'],
      backgroundColor: themeVars.color['scope-accent-subtle-bg'],
    },
  ],
  'addon-popover-included-box',
);

// The bar stays teal in every zone. The figure above it shows the zone.
export const bar = style(
  {
    vars: {
      [PlumaProgressBar.vars.height]: themeVars.space['050'],
      [PlumaProgressBar.vars.backgroundColor]: themeVars.color['surface-track'],
      [PlumaProgressBar.vars.indicatorBackgroundColor]: themeVars.color['scope-accent-solid-bg'],
    },
  },
  'addon-popover-bar',
);
